import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ReleaseSettings } from '../models/releaseSettings.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ReleaseService } from '../services/release.service';
import { FileService } from '../../shared/services/file.service';
import { ReleaseSettingsEditComponent } from '../release-settings-edit/release-settings-edit.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-release-settings-list',
  templateUrl: './release-settings-list.component.html',
  styleUrl: './release-settings-list.component.scss'
})
export class ReleaseSettingsListComponent extends AbstractBiditComponent implements OnInit {
  dataSource = new MatTableDataSource<ReleaseSettings>();
  displayedColumns: string[] =
    ['releaseSettings_Description', 'releaseSettings_Summary', 'releaseSettings_NotificationMessage', 'releaseSettings_FileName', 'releaseSettings_ShowNotification', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  releaseSettings: ReleaseSettings[] = [];
  lastReleaseId: number = null;

  constructor(deviceDetectorService: DeviceDetectorService, private releaseService: ReleaseService,
    private fileService: FileService, 
    public dialog: MatDialog) {
    super(deviceDetectorService)
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;

    this.loadReleaseSettings();
  }

  loadReleaseSettings() {
    this.releaseService.getList()
      .subscribe({
        next: (data) => {
          this.releaseSettings = data;

          this.dataSource.data = this.releaseSettings;
          this.lastReleaseId = this.releaseSettings?.[0].releaseSettings_ID;
        }
      });
  }

  showEdit(releaseSettingId: number) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: releaseSettingId };
    dialogConfig.width = '1100px';
    dialogConfig.maxHeight = '950px';

    const dealerDialogRef = this.dialog.open(ReleaseSettingsEditComponent, dialogConfig);

    dealerDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.loadReleaseSettings();
    });
  }

  checkBoxChanged(event: any) {
    this.isRequesting = true;
    this.releaseService.saveReleaseSetting(this.releaseSettings[0])
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {
          next: (result) => {
            if (result) {
              this.loadReleaseSettings();
            }
          },
          error: (error: string) => this.onError(error)
        });
  }  

  downloadAttachment(releaseSetting: ReleaseSettings) {
    this.releaseService.getReleaseAttachment(releaseSetting.releaseSettings_ID)
      .subscribe({
        next: (data) => {
          this.fileService.downloadFile(data, releaseSetting.releaseSettings_FileName);
        }
      });
  }
}
